import React, {useEffect, useState} from "react";
import Detail from "./Detail/Detail";
import List from "./List/List";
import {HistoryExamine, Tabs} from "components/common";
import {TabsProps} from "antd";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {tabKeys} from "types/enums";
import {setSiderKey} from "redux/reducer/common";

const GlassKiosk = () => {
  document.title = "Quầy kính";
  const activeTab = useAppSelector(state => state.common.activeTab);
  const idBill = useAppSelector(state => state.glassKiot.idBill);
  const idPK = useAppSelector(state => state.common.idPhieuKham);
  const detailBill = useAppSelector(state => state.glassKiot.detailBill);
  const dispatch = useAppDispatch();
  const itemsInit: TabsProps["items"] = [
    {
      key: tabKeys.GLASSES.TAB_1,
      label: "Danh sách đơn kính",
      children: <List />,
    },
    {
      key: tabKeys.GLASSES.TAB_2,
      label: "Chi tiết đơn kính",
      children: <Detail />,
    },
    {
      key: tabKeys.GLASSES.HISTORY_TAB,
      label: "Lịch sử khám bệnh",
      children: <HistoryExamine />,
    },
  ];

  useEffect(() => {
    dispatch(setSiderKey("quayKinh"));
  }, []);

  useEffect(() => {
    itemsInit[1].disabled = detailBill == null;

    setItems([...itemsInit]);
  }, [detailBill]);
  useEffect(() => {
    itemsInit[2].disabled = idPK == null;

    setItems([...itemsInit]);
  }, [idPK]);
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  return (
    <div className="glass page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default GlassKiosk;
